import React, { useState } from 'react';
import { StaticImageData } from 'next/image';

import ArrowLink, { ArrowLinkProps } from 'Elements/Link/Arrow';

import sauce from 'Public/images/clearing/2025/hero/Sauce_Typography.png';
import tileBg from 'Public/images/clearing/2025/card/Blue_Tile_Texture_Cropped.jpg';

import {
    Wrapper,
    Container,
    ImageWrapper,
    ImageBgWrapper,
    StyledImageBg,
    StyledImageForeground,
    SauceImage,
    PreHeading,
    Heading,
    HeadingContainer,
    HiddenLink,
    LinkWrapper
} from './Card.styled';

export interface Props {
    image: {
        alt?: string;
        src: StaticImageData | string;
    };
    heading: string;
    button: ArrowLinkProps;
}

const Card: React.FC<Props> = props => {
    const { image, heading, button } = props;
    const [isHovering, setIsHovering] = useState(false);

    return (
        <Wrapper>
            <Container>
                <ImageWrapper>
                    <ImageBgWrapper>
                        <StyledImageBg
                            src={tileBg}
                            alt=""
                            width={276}
                            height={130}
                            $isHovering={isHovering}
                        />
                    </ImageBgWrapper>
                    <StyledImageForeground
                        src={image.src}
                        alt={image.alt || ''}
                        width={210}
                        height={240}
                        $isHovering={isHovering}
                    />
                </ImageWrapper>
                <HeadingContainer>
                    <PreHeading>
                        The
                        <span>
                            <SauceImage src={sauce} alt="" width={70} height={35} />
                        </span>
                        of success
                    </PreHeading>
                    <Heading>{heading}</Heading>
                </HeadingContainer>
                <LinkWrapper>
                    <ArrowLink
                        {...button}
                        iconOutline
                        iconBorder={false}
                        isHovered={isHovering}
                        variant="default"
                    />
                </LinkWrapper>
            </Container>
            <HiddenLink
                href={button.href}
                tabIndex={-1}
                aria-hidden={true}
                onMouseOver={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            />
        </Wrapper>
    );
};

export default Card;
